export default "__VITE_ASSET__DenCq$dh__"